export default {
  water2nd: '水二局',
  wood3rd: '木三局',
  metal4th: '金四局',
  earth5th: '土五局',
  fire6th: '火六局',
} as const;
